<template>
  <div class="fixedMenu">
    <ul>
      <li @click="handleGuide">
        <div class="menuTitle">新 手<br />引 导</div>
        <i class="icon guide" />
      </li>
      <li @click="goHome">
        <!-- <router-link to="/"> -->
        <div class="menuTitle">返 回<br />主 页</div>
        <!-- </router-link> -->
        <i class="icon home" />
      </li>
      <li @click="goQA">
        <div class="menuTitle">问 答</div>
        <i class="icon QA" />
      </li>
      <!-- <li>
        <div>我 要<br />反 馈</div>
        <i class="icon feedback" />
      </li> -->
      <li>
        <div class="menuTitle">
          APP\<br />小程序
          <div
            style="width: 103px;position: absolute;height: 100px;left: -16px;"
          >
            <div class="hoverLayout">
              <!--  -->
              <div class="hoverList">
                <div class="hoverItem">
                  <QRcode
                    QRlink="https://chrivc.com/mobile/#/appdownload"
                    :qrwidth="125"
                    :qrheight="125"
                    class="qr"
                  />
                  <div>扫码下载</div>
                  <div>个人服务APP</div>
                </div>
                <div class="hoverItem">
                  <img
                    src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/miniQr.png"
                    class="qr"
                  />
                  <div>扫码打开个人服务</div>
                  <div>微信小程序</div>
                </div>
              </div>
              <div class="version" @click="$router.push('/version')"><i class="icon_version"/>查看APP版本更新记录>></div>
            </div>
          </div>

          <!-- <div class="hoverList">
            <div class="hoverItem">
              <QRcode
                QRlink="https://chrivc.com/mobile/#/appdownload"
                :qrwidth="125"
                :qrheight="125"
                class="qr"
              />
              <div>扫码下载</div>
              <div>个人服务APP</div>
            </div>
            <div class="hoverItem">
              <img
                src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/miniQr.png"
                class="qr"
              />
              <div>扫码打开个人服务</div>
              <div>微信小程序</div>
            </div>
          </div> -->
        </div>
        <i class="icon app" />
      </li>
      <li @click="handleGoTop">
        <div class="menuTitle">返 回<br />顶 部</div>
        <i class="icon goTop" />
      </li>
    </ul>
    <Guide ref="guide" />
  </div>
</template>

<script>
import Guide from "./Guide.vue";
import QRcode from "./QRcode.vue";
export default {
  components: { Guide, QRcode },
  methods: {
    handleGuide() {
      //   this.$emit("handleGuide");
      console.log("handleGuide");
      this.$refs.guide.handleShow();
    },
    goHome() {
      this.$router.push("/");
    },
    handleQA() {
      this.$emit("handleQA");
    },
    handleFeedBack() {
      this.$emit("handleFeedBack");
    },
    handleGoTop() {
      document.documentElement.scrollTop = 0;
    },
    goQA() {
      this.$router.push("/QA");
    }
  }
};
</script>

<style scoped lang="scss">
.fixedMenu {
  width: 54px;
  border-radius: 6px;
  position: fixed;
  right: 1%;
  top: 40%;
  bottom: 50%;
  box-sizing: border-box;
  z-index: 1;
  ul {
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    list-style: none;
    font-size: 12px;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    box-shadow: 0 0 5px 0 #eee;
    li {
      width: 54px;
      height: 58px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;

      .menuTitle {
        display: none;
      }
      &:hover {
        .menuTitle {
          width: 100%;
          height: 100%;
          background: #254688;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        i {
          display: none;
        }

        .hoverLayout {
          padding: 20px 0;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 346px;
          height: 268px;
          background: #fff;
          position: absolute;
          right: 100px;
          border: 1px solid #ededed;
          box-shadow: 0px 0px 0px 0px #e3e3e3;
          border-radius: 10px;
          .hoverList {
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-evenly;
            .hoverItem {
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #6e6e6e;
              line-height: 18px;
              .qr {
                margin-bottom: 10px;
              }
              img {
                width: 125px;
                height: 125px;
                margin-bottom: 10px;
              }
            }
          }

          .version {
            margin-top: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 232px;
            height: 33px;
            background: #f5f5f5;
            border: 1px solid #efefef;
            border-radius: 4px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #6e6e6e;
            .icon_version{
              background: url("../assets/icon_version.png");
              background-size: cover;
              width: 12px;
              height: 12px;
              display: inline-block;
              margin-right: 8px;
            }
          }
        }
      }
      &:first-child {
        &:hover {
          div {
            width: 100%;
            height: 100%;
            background: #254688;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px 6px 0 0;
          }
          i {
            display: none;
          }
        }
      }
      &:last-child {
        &:hover {
          div {
            width: 100%;
            height: 100%;
            background: #254688;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0 0 6px 6px;
          }
          i {
            display: none;
          }
        }
      }
      &:not(:last-child) {
        &::after {
          content: "";
          border-bottom: 1px solid rgba(223, 223, 223, 0.28);
          position: absolute;
          bottom: 1px;
          width: 22px;
        }
      }
    }

    .icon {
      width: 20px;
      height: 20px;
      display: inline-block;
      background-size: cover !important;
    }
    .guide {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/fixedMenu1.png");
    }
    .home {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/fixedMenu2.png");
    }
    .QA {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/fixedMenu3.png");
    }
    .feedback {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/fixedMenu4.png");
    }
    .goTop {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/fixedMenu5.png");
    }
    .app {
      width: 14px;
      height: 22px;
      background: url("../assets/fixedMenu6.png");
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FixedMenu.vue